import React from 'react';
import Highcharts from 'highcharts/highcharts';
import HighchartsReact from 'highcharts-react-official';

import data_1 from './data_1';
import data_2 from './data_2';
import data_4 from './data_4';

const base = {
  credits: {
    enabled: false
  },
  plotOptions: {
    series: {
      enableMouseTracking: false,
      lineWidth: 1,
      marker: { enabled: true }
    }
  },
  yAxis: {
    title: { enabled: false },
    min: -0.2,
    max: 0.3,
    tickInterval: 0.1
  }
};

const options1 = {
  ...base,
  title: {
    text: 'Upsampling 2x',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      data: data_1.slice(0, 100),
      marker: { radius: 2 },
      name: 'Original Training Data'
    },
    {
      data: data_2.slice(0, 50),
      marker: { radius: 2 },
      name: 'Resampled Data'
    }
  ]
};

const options2 = {
  ...base,
  title: {
    text: 'Upsampling 4x',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      data: data_1.slice(0, 100),
      marker: { radius: 2 },
      name: 'Original Training Data'
    },
    {
      data: data_4.slice(0, 25),
      marker: { radius: 2 },
      name: 'Resampled Data'
    }
  ]
};

const opts = { style: { height: '300px', width:'50%' }};

function SamplingRate() {
  return (
    <div className="mb-4">
      <h5 className="text-uppercase">Sampling Rate & Saturation</h5>
      <p>
        The arbitrary long periods of oscillations in the degrade-and-fire model compared to delay time are especially difficult to predict.
        Upsampling by a small factor helps mitigate clustering points and noise while closely tracking the underlying data.
      </p>
      <div className="d-flex">
        <HighchartsReact
          highcharts={Highcharts}
          options={options1}
          containerProps={opts}
        />
        <HighchartsReact
          highcharts={Highcharts}
          options={options2}
          containerProps={opts}
        />
      </div>
    </div>
  );
}

export default SamplingRate;
